import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchConversationsApi,
  fetchMessengerCheckInClientsListApi,
  filterConversationsApi,
  resetUnreadCountApi,
} from "../../api/messengerApi";
import * as Endpoints from "../../entities/Endpoints";

//Async thunk to fetch conversations
export const fetchConversations = createAsyncThunk(
  Endpoints.GET_CONVERSION_DETAILS,
  async ({ coachId }, { rejectWithValue }) => {
    try {
      return await fetchConversationsApi(coachId);
    } catch (error) {
      return rejectWithValue(
        error?.data?.message || "Error fetching conversations"
      );
    }
  }
);

//Async thunk to fetch conversations
export const fetchMessengerCheckInClientsList = createAsyncThunk(
  Endpoints.GET_MESSENGER_CHECKIN_CLIENTS_LIST,
  async ({ coachId }, { rejectWithValue }) => {
    try {
      return await fetchMessengerCheckInClientsListApi(coachId);
    } catch (error) {
      return rejectWithValue(
        error?.data?.message || "Error fetching conversations"
      );
    }
  }
);

export const filterConversations = createAsyncThunk(
  "messenger/filterConversations",
  async ({ coachId, filter }, { rejectWithValue }) => {
    try {
      return await filterConversationsApi(coachId, filter);
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to filter conversations"
      );
    }
  }
);

export const resetUnreadCountThunk = createAsyncThunk(
  `${Endpoints.RESET_UNREAD_COUNT}`,
  async ({ conversationSid }, { rejectWithValue }) => {
    try {
      return await resetUnreadCountApi(conversationSid);
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to filter conversations"
      );
    }
  }
);

//Messenger slice
const messengerSlice = createSlice({
  name: "messenger",
  initialState: {
    conversations: [],
    messengerCheckInClientsList: [],
    unreadCheckInCount: 0,
    isLoading: false,
    isMessengerCheckInClientsListLoading: false,
    error: null,
  },
  reducers: {
    resetMessengerState: (state) => {
      state.error = null;
    },
    updateConversationUnreadCount: (state, action) => {
      const { conversationId, unreadCount, lastMessageTime, dateCreated } =
        action.payload;

      // Find and update the specific conversation
      const conversationIndex = state.conversations.findIndex(
        (conv) => conv.conversationId === conversationId
      );

      if (conversationIndex !== -1) {
        state.conversations[conversationIndex].unreadCount = unreadCount || 0;
        state.conversations[conversationIndex].lastMessageTime =
          lastMessageTime ;
        state.conversations[conversationIndex].dateCreated = dateCreated;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchConversations.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchConversations.fulfilled, (state, action) => {
        state.isLoading = false;
        state.conversations = action.payload;
      })
      .addCase(fetchConversations.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(filterConversations.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(filterConversations.fulfilled, (state, action) => {
        state.isLoading = false;
        state.conversations = action.payload.data;
      })
      .addCase(filterConversations.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchMessengerCheckInClientsList.pending, (state) => {
        state.isMessengerCheckInClientsListLoading = true;
        state.error = null;
      })
      .addCase(fetchMessengerCheckInClientsList.fulfilled, (state, action) => {
        state.isMessengerCheckInClientsListLoading = false;
        state.messengerCheckInClientsList = action.payload.data || [];
        state.unreadCheckInCount = action.payload.count || 0;
      })
      .addCase(fetchMessengerCheckInClientsList.rejected, (state, action) => {
        state.isMessengerCheckInClientsListLoading = false;
        state.error = action.payload;
        state.messengerCheckInClientsList = [];
        state.unreadCheckInCount = 0;
      });
  },
});

export const { resetMessengerState, updateConversationUnreadCount } =
  messengerSlice.actions;
export const messengerReducer = messengerSlice.reducer;
